import { c as _c } from "react/compiler-runtime";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { PackagingMode } from "@/utils/resolvePackagingMode";
interface Props {
  mode: PackagingMode;
  showWarning: boolean;
}
export function PackagingQuantityWarning(t0) {
  const $ = _c(3);
  const {
    mode,
    showWarning
  } = t0;
  if (!showWarning) {
    return null;
  }
  const text = `Please update your ${mode} quantity selection below`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconAlertTriangle size={18} aria-hidden="true" className="shrink-0 text-amber-600" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <div className="mx-5 mt-3 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3" role="alert">{t1}<p className="text-sm text-amber-800">{text}</p></div>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}